<template>
  <div id="page-user-edit">
    <div class="vx-row" >
          <div class="upload-container">
            <!-- Drag and Drop -->
            <div class="drag-and-drop" @dragover.prevent="handleDragOver" @dragleave="handleDragLeave"
              @drop="handleDrop" @click="openFileInput">
              <p>Drag and drop your files here or click to select</p>
            </div>

            <!-- Hidden file input -->
            <input multiple type="file" ref="fileInput" @change="handleFileChange" style="display: none" accept="*/*" />

            <!-- File Upload Progress -->
            <vs-progress v-if="uploadProgress > 0 && uploadProgress < 100" :percent="uploadProgress" color="primary" />

            <!-- File Preview -->
            <div class="file-preview">
              <div v-for="file in overViewFile" :key="file.name" class="file-item">
                <div class="file-icon">
                  <!-- Display a preview for image files -->
                  <img v-if="file.type.startsWith('image/')" :src="file.preview" alt="File Preview" />
                  <!-- Generic icon for other file types -->
                </div>
                <!-- File Details -->
                <div class="file-details">
                  <p class="file-name">{{ file.name }}</p>
                  <p class="file-size">{{ formatFileSize(file.size) }}</p>
                </div>
              </div>
            </div>
          </div>
    </div>
    <h4>Queue</h4><br/>
          <vs-table :data="fileList" class="table-dark-inverted" :max-items="1000">
            <template slot="thead">
              <vs-th>Filename</vs-th>
              <vs-th>Date upload</vs-th>
              <vs-th>Status</vs-th>
              <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td v-if="tr.name != '.ftpquota' && tr.name != 'done'"><a :href="getPreviewFile(tr.name)"
                    target="_blank">{{ tr.name }}</a></vs-td>
                <vs-td v-if="tr.name != '.ftpquota' && tr.name != 'done'">{{ formatDateTime(tr.date) }}</vs-td>
                <vs-td v-if="tr.name != '.ftpquota' && tr.name != 'done' && tr.status">{{ tr.status }}</vs-td>
                <vs-td
                  v-else-if="tr.name != '.ftpquota' && tr.name != 'done' && !tr.name.endsWith('.pdf') && !tr.name.endsWith('.jpg') && !tr.name.endsWith('.png') && !tr.name.endsWith('.jpeg')"><vs-chip
                    color="orange">NOT READABLE</vs-chip></vs-td>
                <vs-td
                  v-else-if="tr.name != '.ftpquota' && tr.name != 'done' && (tr.name.endsWith('.PNG') || tr.name.endsWith('.JPG'))"><vs-chip
                    color="red">FAILED</vs-chip></vs-td>
                <vs-td v-else-if="tr.name != '.ftpquota' && tr.name != 'done'">
                  <vs-chip color="green">IN QUEUE... </vs-chip>
                </vs-td>
                <vs-td v-if="tr.name != '.ftpquota' && tr.name != 'done'"><feather-icon v-on:click="deleteFile(tr.name)"
                    icon="TrashIcon" svgClasses="h-4 w-4" /></vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <br/>
  </div>
</template>


<script>
import axios from 'axios';
// Store Module
import moduleOperationList from '@/store/operation/moduleOperationList.js'

export default {
  data() {
    return {
      fileList: [],
      selectedFile: {},
      overViewFile: {},
      uploading: false, // Indicateur pour montrer si un téléchargement est en cours
      uploadProgress: 0, // Pourcentage de progression du téléchargement
    };
  },
  methods: {
    async deleteFileOne() {
      try {
        await axios.post('https://xylo.codesinn.com/api/outlay/deletefile', { fileName: this.fileNameToDelete }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }).then((response) => {
          this.loadFileList()
        });
      } catch (error) {
        console.error('Error while deleting file:', error);
      }
    },
    deleteFile(name) {
      this.fileNameToDelete = name;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm Delete",
        text: `You are about to delete the file ${name}`,
        accept: this.deleteFileOne,
        acceptText: "Delete File"
      });
    },
      formatDateTime(rawDateTime) {
      const date = new Date(rawDateTime);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    getPreviewFile(name) {
      return "https://xylo.codesinn.com/api/filesdl/" + name
    },
    async loadFileList() {
      try {
        const response = await axios.get('https://xylo.codesinn.com/api/ftp/files');
        this.fileList = response.data.sort((a, b) => {
          // Convertir les dates en timestamps et trier
          return new Date(b.rawModifiedAt) - new Date(a.rawModifiedAt);
        });
      } catch (error) {
        console.error("Erreur lors de la récupération des fichiers : ", error);
      }
    },
    formatFileSize(fileSize) {
      if (fileSize < 1024) return fileSize + ' B';
      if (fileSize < 1024 * 1024) return (fileSize / 1024).toFixed(2) + ' KB';
      if (fileSize < 1024 * 1024 * 1024) return (fileSize / (1024 * 1024)).toFixed(2) + ' MB';
      return (fileSize / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
    },
    handleDragOver(event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy'; // Indique que le glisser-déposer effectuera une copie

      // Ajouter la classe de tremblement
      this.addShakeAnimation();

      // Supprimer la classe après un délai
      setTimeout(() => {
        this.removeShakeAnimation();
      }, 2000); // Correspond à la durée de l'animation CSS
    },
    handleDragLeave(event) {
      event.preventDefault();
      // Réinitialisez l'apparence lorsque le curseur quitte la zone de glisser-déposer
      // Vous pouvez ajouter un style CSS pour indiquer le changement visuel ici
    },
    handleDrop(event) {
      event.preventDefault();
      let newFiles = event.dataTransfer.files;
      if (this.selectedFile) {
        // Utilisez Array.from pour convertir FileList en Array, puis concaténez
        this.selectedFile = newFiles;
        this.overViewFile = [...Array.from(this.overViewFile), ...Array.from(newFiles)];
      } else {
        this.selectedFile = Array.from(newFiles);
        this.overViewFile = Array.from(newFiles);
      }

      this.uploadFile();
    },

    addShakeAnimation() {
      const dragAndDropElement = this.$el.querySelector('.drag-and-drop');
      dragAndDropElement.classList.add('shake-animation');
    },

    removeShakeAnimation() {
      const dragAndDropElement = this.$el.querySelector('.drag-and-drop');
      dragAndDropElement.classList.remove('shake-animation');
    },

    handleFileChange(event) {
      let newFiles = event.target.files;
      if (this.selectedFile) {
        // Utilisez Array.from pour convertir FileList en Array, puis concaténez
        this.selectedFile = newFiles;
        this.overViewFile = [...Array.from(this.overViewFile), ...Array.from(newFiles)];
      } else {
        this.selectedFile = Array.from(newFiles);
        this.overViewFile = Array.from(newFiles);
      }
      //this.selectedFile = event.target.files;
      this.uploadFile(); // Appeler la méthode uploadFile lorsque des fichiers sont sélectionnés
    },
    openFileInput() {
      // Ouvrez l'explorateur de fichiers lorsque la zone de glisser-déposer est cliquée
      this.$refs.fileInput.click();
    },
    uploadFile() {
      if (this.selectedFile && this.selectedFile.length > 0) { // Assurez-vous que des fichiers sont sélectionnés
        // Créez un objet FormData pour envoyer les fichiers
        const formData = new FormData();
        for (let i = 0; i < this.selectedFile.length; i++) {
          formData.append('files', this.selectedFile[i], localStorage.getItem("login-username").toLowerCase() + "_" + this.selectedFile[i].name.toLowerCase()); // Ajoutez chaque fichier individuellement
          const file = this.selectedFile[i];
          const reader = new FileReader();

          reader.onload = (e) => {
            // Ajoutez une propriété 'preview' à chaque objet de fichier
            this.$set(file, 'preview', e.target.result);
          };

          reader.readAsDataURL(file); // Lire le fichier pour l'aperçu
        }

        // Indiquez que le téléchargement est en cours
        this.uploading = true;

        // Effectuez la requête POST pour télécharger les fichiers
        axios.post('https://xylo.codesinn.com/api/outlay/uploadtoftp', formData, {
          headers: {
            'Content-Type': 'multipart/form-data', // En-tête Content-Type approprié
            // Autres en-têtes personnalisés si nécessaires
          },
          // Configurer une fonction de suivi de la progression
          onUploadProgress: progressEvent => {
            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            this.uploadProgress = progress; // Mettez à jour la progression
            console.log(progress);
          },
        })
          .then(response => {
            // Gérez la réponse ici en cas de succès
            console.log('Files successfully uploaded.', response);
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "Files successfully uploaded.",
              position: "bottom-right",
              duration: 5000, // Durée de l'animation
              progress: "auto", // Afficher une barre de progression
            });

              this.$router.push("/efacturalist-ing/").catch(() => { });

          })
          .catch(error => {
            // Gérez les erreurs ici
            console.error('Error while uploading files.', error);
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "Error while uploading files.",
              position: "bottom-right",
              duration: 5000, // Durée de l'animation
            });
          })
          .finally(() => {
            // Réinitialisez l'état de la progression et du téléchargement
            this.uploading = false;
            this.uploadProgress = 0;
          });
      }
    },
  },
  async created() {
    this.$vs.loading()
    if (localStorage.getItem("login-roles").toLowerCase().includes("user")) {
      this.$vs.notify({
        title: "Denied",
        text: "Access to the this page is reserved for administrators",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/dashboard/analytics" });
    }
    if (!moduleOperationList.isRegistered) {
      this.$store.registerModule('operationList', moduleOperationList)
      moduleOperationList.isRegistered = true
    }
    this.$store.dispatch('operationList/fetchExpenses')
      .then(response => {
        this.$vs.loading.close()
      })
      .catch(err => { console.error(err) })
    this.loadFileList()
  }
};
</script>

<style>
.upload-container {
  padding: 20px;
  border-radius: 8px;
  max-width: 620px;
  margin: auto;
}

.file-preview {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

/* Ajoutez des styles CSS pour personnaliser l'apparence de l'aperçu des fichiers */
.file-icon img {
  width: 50px;
  height: 50px;
  object-fit: cover;
  margin-right: 10px;
}

.file-preview {
  display: flex;
  flex-wrap: wrap;
}

.file-item {
  display: flex;
  align-items: center;
  margin: 8px;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f0f0f0;
}

.file-icon img {
  width: 100px;
  height: auto;
}

.file-details {
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.file-name {
  font-weight: bold;
  font-size: 11px;
}

.file-size {
  font-size: 10px;
  color: #666;
}

.drag-and-drop {
  border: 1px dashed #e74c3c;
  /* Couleur de la bordure en rouge plus vif */
  padding: 100px;
  text-align: center;
  cursor: pointer;
  background-color: #f5f5f5;
  /* Couleur d'arrière-plan gris très clair */
  border-radius: 10px;
  /* Coins arrondis */
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  /* Ombre subtile pour une profondeur légère */
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
  /* Transition lisse pour plusieurs propriétés */

}

.drag-and-drop:hover {
  background-color: #f4f4f4;
  /* Fond légèrement plus foncé au survol */
  border-color: #000;
  /* Changement de couleur de la bordure */
  box-shadow: 0px 12px 12px rgba(0, 0, 0, 0.1);
  /* Ombre plus prononcée pour un effet de soulèvement */
}

.drag-and-drop p {
  font-size: 18px;
  color: black;
  /* Couleur du texte en noir */
}

@keyframes shake {

  0%,
  100% {
    transform: translateX(0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translateX(-10px);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translateX(10px);
  }
}

.shake-animation {
  animation: shake 0.8s ease-in-out;
}
</style>
